import { ReactElement } from "react";

const TopBar = ({ children }: { children: ReactElement }) => {
  return <div className="h-[55px] shadow-sm ring-1 ring-black/5 flex items-center px-8">{children}</div>;
};

export default TopBar;
